import { FC, ReactNode } from 'react'
import { Box, TextField, type TextFieldProps } from '@mui/material'

// Render the field's icon as an absolute overlay (not a startAdornment) so the
// <input> spans the full width — browser autofill then tints the whole field,
// icon area included, matching the semantic look. (A startAdornment sits beside
// the input, leaving the icon slot un-tinted on autofill.)
export const IconField: FC<{ icon: ReactNode } & TextFieldProps> = ({ icon, sx, ...props }) => (
  <Box sx={{ position: 'relative' }}>
    <Box
      sx={{
        position: 'absolute',
        left: '14px',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        pointerEvents: 'none',
        zIndex: 1,
      }}
    >
      {icon}
    </Box>
    <TextField
      fullWidth
      sx={[{ '& .MuiOutlinedInput-input': { pl: '46px' } }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...props}
    />
  </Box>
)

export default IconField
